<template>
  <v-card flat class="mx-2 mb-10">
    <v-text-field
      dense
      v-model="search"
      append-icon="mdi-magnify"
      :label="$t('components.analytics.AnalyticsDataTableDialog.search')"
      single-line
      hide-details
      solo
      max-with="200"
    ></v-text-field>
    <v-data-iterator :search="search" :items="myThgs" :items-per-page="6">
      <template v-slot:default="props">
        <v-row>
          <v-col cols="12" md="6" v-for="(myThg, i) in props.items" :key="i">
            <thg-vehicle-card :myThg="myThg" @refresh="refresh" />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-card>
</template>

<script lang="ts">
import ThgVehicleCard from "@/components/thg/ThgVehicleCard.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { PartnerColor } from "@/lib/partnerColor";
import { ThgThgMeViewModelGen } from "@/services/thg/v1/data-contracts";

@Component({
  components: {
    ThgVehicleCard
  }
})
export default class ThgVehicleCardIterator extends Vue {
  @Prop()
  myThgs!: ThgThgMeViewModelGen[];

  search = "";

  newCar() {
    this.$router.push({ path: "/thghome" });
  }

  partnerColor = new PartnerColor();

  refresh() {
    this.$emit("refresh");
  }
}
</script>

<style>
.form {
  margin-top: 20px;
}
</style>
